import '@fancyapps/fancybox';
import {animateInViewport} from "../transition";

$( '.carousel' ).each( function() {
	var $this = $( this );
	let autoplay = $this.data( 'autoplay' );

	let swiperConfig = {
		loop: true,
		navigation: {
			nextEl: $this.parents( '.carousel-container' ).find( '.carousel-next' )[ 0 ],
			prevEl: $this.parents( '.carousel-container' ).find( '.carousel-previous' )[ 0 ],
		},
		slidesPerView: 1,
		spaceBetween: 50,
		grabCursor: true,
		speed: 1000,
		effect: 'fade',
		fadeEffect: {
			crossFade: true,
		},
		pagination: {
			el: '.swiper-pagination',
			type: 'bullets',
		},
	};

	if ( autoplay ) {
		swiperConfig.autoplay = {
			delay: 1500,
		};
	}

	var swiper = new Swiper( this, swiperConfig );
} );

$( '.hero-carousel' ).each( function() {
	var $this = $( this );

	var delay = $this.attr( 'data-delay' ) ? $this.attr( 'data-delay' ) : 3000;

	var swiper = new Swiper( this, {
		loop: true,
		navigation: {
			nextEl: $this.parents( '.carousel-container' ).find( '.carousel-next' )[ 0 ],
			prevEl: $this.parents( '.carousel-container' ).find( '.carousel-previous' )[ 0 ],
		},
		slidesPerView: 1,
		spaceBetween: 50,
		grabCursor: true,
		speed: 1000,
		effect: 'fade',
		fadeEffect: {
			crossFade: true,
		},
		pagination: {
			el: '.swiper-pagination',
			type: 'bullets',
		},
		autoplay: {
			delay: delay,
		},
	} );
} );

$( '.property-carousel' ).each( function() {
	var $this = $( this );
	let autoplay = $this.data( 'autoplay' );

	let swiperConfig = {
		loop: true,
		navigation: {
			nextEl: $this.parents( '.carousel-container' ).find( '.carousel-next' )[ 0 ],
			prevEl: $this.parents( '.carousel-container' ).find( '.carousel-previous' )[ 0 ],
		},
		slidesPerView: 1,
		spaceBetween: 50,
		grabCursor: true,
		speed: 1000,
		effect: 'fade',
		autoHeight: true,
		fadeEffect: {
			crossFade: true,
		},
		pagination: {
			el: '.swiper-pagination',
			type: 'bullets',
		},
	};

	if ( autoplay ) {
		swiperConfig.autoplay = {
			delay: 1500,
		};
	}

	var swiper = new Swiper( this, swiperConfig );
} );

$( '.intro-carousel' ).each( function() {
	var $this = $( this );
	let swiperConfig = {
		loop: true,
		slidesPerView: 1,
		spaceBetween: 50,
		grabCursor: true,
		speed: 2000,
		effect: 'fade',
		fadeEffect: {
			crossFade: true,
		},
		autoplay: {
			delay: 4000,
		},
	};

	var swiper = new Swiper( this, swiperConfig );
} );
